<template>
  <div class="navHead">
    <img src="../assets/img/logo.svg" />

    <div class="rjVox fsFLex">
      <div class="menu-item" @click="toHome">首页</div>
      <!-- 修改下载菜单项 -->
      <div class="menu-item" @click="toDownload">产品下载</div>
      <div class="menu-item" @click="toPrice">产品价格</div>

      <div class="syBtn" @click="toRegister">开启免费试用</div>
      <!-- 修改登录按钮 -->
      <div class="lgBtn" @click="toLogin">登录</div>
    </div>

    <div class="lxkf">
      <div style="position: relative">
        <img src="../assets/img/lianxi.svg" />
        <a target="_blank" :href="userService" class="tl2"></a>
        <a target="_blank" :href="userService" class="tl1"></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userService: 'https://t.me/qlong0vip'
    }
  },
  mounted() {

},
methods: {
  // 新增首页回到顶部方法
  toHome() {
    if (this.$route.path !== '/') {
      this.$router.push('/');
    }
    window.document.body.querySelector('#app').scrollTo({
      top: 0,
      behavior: "smooth"
    });
  },
  toPrice() {
    window.open(`https://download.${window.location.host}/price`, '_blank')
  },

  // 新增登录跳转方法
  toLogin() {
    window.open(`https://user.${window.location.host}`, '_blank')
  },

  // 新增注册跳转方法
  toRegister() {
    window.open(`https://user.${window.location.host}/register`, '_blank')
  },


  // 新增下载跳转方法
  toDownload() {
    window.open(`https://download.${window.location.host}/download`, '_blank')
  },
},
}
</script>

<style lang="scss" scoped>
.lxkf {
  position: fixed;
  right: 15px;
  bottom: 15vh;

  img {
    width: 100px;
  }

  a {
    z-index: 999;
    text-decoration: none;
    width: 80px;
    height: 45px;
    position: absolute;
    background-color: transparent;
    right: 0;
  }

  a.tl1 {
    bottom: 75px;
  }

  a.tl2 {
    bottom: 125px;
  }
}

.rjVox {
  gap: 38px;

  >div {
    font-family: 'Poppins';
    font-style: normal;
    font-size: 20px;
    line-height: 30px;
    color: #4d4c5a;
    cursor: pointer;
  }
}

.syBtn {
  background: #4d4c5a;
  border-radius: 26.5px;
  font-family: 'Poppins';
  font-style: normal;
  font-size: 20px;
  line-height: 30px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  padding: 12px 30px;
  color: #ffffff !important;
  width: 6.3em;
}

.lgBtn {
  box-sizing: border-box;
  border: 1px solid #2ed36a;
  border-radius: 26.5px;
  font-family: 'Poppins';
  font-style: normal;
  font-size: 20px;
  line-height: 30px;
  padding: 12px 30px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  color: #2ed36a !important;
}

.navHead {
  top: 0;
  position: sticky;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 55px;
  height: 105px;
  line-height: 105px;
  background-color: #fff;

  >img {
    width: 180px;
  }
}
</style>
